import { render, staticRenderFns } from "./borrowTypeManageList.vue?vue&type=template&id=05512786&scoped=true"
import script from "./borrowTypeManageList.vue?vue&type=script&lang=js"
export * from "./borrowTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./borrowTypeManageList.vue?vue&type=style&index=0&id=05512786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05512786",
  null
  
)

export default component.exports